export default [
    {
        path: '/pages/admin/userIntegral',
        name: '/pages/admin/userIntegral',
        meta: { title: '用户积分' },
        component: () => import('@/views/admin/userIntegral.vue')
    },
    {
        path: '/pages/admin/systemGoldSettingManage',
        name: '/pages/admin/systemGoldSettingManage',
        component: () => import('@/views/admin/systemGoldSettingManage.vue')
    },
    {
        path: '/pages/admin/storeOrderCartManage',
        name: '/pages/admin/storeOrderCartManage',
        meta: { title: '商品订单' },
        component: () => import('@/views/admin/storeOrderCartManage.vue')
    },
    {
        path: '/pages/admin/storeOrderManage',
        name: '/pages/admin/storeOrderManage',
        meta: { title: '商城订单' },
        component: () => import('@/views/admin/storeOrderManage.vue')
    },
    {
        path: '/pages/admin/exceptionOrderManage',
        name: '/pages/admin/exceptionOrderManage',
        meta: { title: '异常订单' },
        component: () => import('@/views/admin/exceptionOrderManage.vue')
    },
    {
        path: '/pages/admin/deliverySettlementManage',
        name: '/pages/admin/deliverySettlementManage',
        meta: { title: '配送费结算' },
        component: () => import('@/views/admin/deliverySettlementManage.vue')
    },
    {
        path: '/pages/admin/freeDeliveryConfigManage',
        name: '/pages/admin/freeDeliveryConfigManage',
        meta: { title: '满免配送配置' },
        component: () => import('@/views/admin/freeDeliveryConfigManage.vue')
    },
    {
        path: '/pages/admin/storeIntegral',
        name: '/pages/admin/storeIntegral',
        meta: { title: '商家积分' },
        component: () => import('@/views/admin/storeIntegral.vue')
    },
    {
        path: '/pages/admin/shopTypeManage',
        name: '/pages/admin/shopTypeManage',
        meta: { title: '店铺类型' },
        component: () => import('@/views/admin/shopTypeManage.vue')
    },
    {
        path: '/pages/admin/shopProductType',
        name: '/pages/admin/shopProductType',
        meta: { title: '商圈菜单' },
        component: () => import('@/views/admin/shopProductType.vue')
    },
    {
        path: '/pages/admin/shopCommunity',
        name: '/pages/admin/shopCommunity',
        meta: { title: '小区店铺' },
        component: () => import('@/views/admin/shopCommunity.vue')
    },
    {
        path: '/pages/admin/merchantShop',
        name: '/pages/admin/merchantShop',
        component: () => import('@/views/admin/merchantShop.vue')
    },
    {
        path: '/pages/admin/merchantManage',
        name: '/pages/admin/merchantManage',
        meta: { title: '商家' },
        component: () => import('@/views/admin/merchantManage.vue')
    },
    {
        path: '/pages/admin/mainCategoryProduct',
        name: '/pages/admin/mainCategoryProduct',
        meta: { title: '专区商品' },
        component: () => import('@/views/admin/mainCategoryProduct.vue')
    },
    {
        path: '/pages/admin/mainCategoryManage',
        name: '/pages/admin/mainCategoryManage',
        meta: { title: '专区目录' },
        component: () => import('@/views/admin/mainCategoryManage.vue')
    },
    {
        path: '/pages/admin/integralWithdrawal',
        name: '/pages/admin/integralWithdrawal',
        meta: { title: '积分提现' },
        component: () => import('@/views/admin/integralWithdrawal.vue')
    },
    {
        path: '/pages/admin/integralSetting',
        name: '/pages/admin/integralSetting',
        meta: { title: '积分设置' },
        component: () => import('@/views/admin/integralSetting.vue')
    },
    {
        path: '/pages/admin/integralDetail',
        name: '/pages/admin/integralDetail',
        meta: { title: '积分交易' },
        component: () => import('@/views/admin/integralDetail.vue')
    },
    {
        path: '/pages/admin/housekeepingTypeManage',
        name: '/pages/admin/housekeepingTypeManage',
        meta: { title: '服务菜单' },
        component: () => import('@/views/admin/housekeepingTypeManage.vue')
    },
    {
        path: '/pages/admin/goldWithdrawal',
        name: '/pages/admin/goldWithdrawal',
        meta: { title: '金币提现' },
        component: () => import('@/views/admin/goldWithdrawal.vue')
    },
    {
        path: '/pages/admin/goldDetail',
        name: '/pages/admin/goldDetail',
        meta: { title: '金币交易' },
        component: () => import('@/views/admin/goldDetail.vue')
    },
    {
        path: '/pages/admin/goldBuyCartManage',
        name: '/pages/admin/goldBuyCartManage',
        component: () => import('@/views/admin/goldBuyCartManage.vue')
    },
    {
        path: '/pages/admin/gold',
        name: '/pages/admin/gold',
        meta: { title: '小区金币' },
        component: () => import('@/views/admin/gold.vue')
    },
    {
        path: '/pages/admin/chainSupplierManage',
        name: '/pages/admin/chainSupplierManage',
        meta: { title: '供应链' },
        component: () => import('@/views/admin/chainSupplierManage.vue')
    },
    {
        path: '/pages/admin/ChainProduct',
        name: '/pages/admin/ChainProduct',
        component: () => import('@/views/admin/ChainProduct.vue')
    },
    {
        path: '/pages/admin/chainInoutOrder',
        name: '/pages/admin/chainInoutOrder',
        meta: { title: '集采订单' },
        component: () => import('@/views/admin/chainInoutOrder.vue')
    },
    {
        path: '/pages/admin/auditShopCommunity',
        name: '/pages/admin/auditShopCommunity',
        meta: { title: '入驻小区' },
        component: () => import('@/views/admin/auditShopCommunity.vue')
    },
    {
        path: '/pages/admin/auditOpenShop',
        name: '/pages/admin/auditOpenShop',
        meta: { title: '开店审核' },
        component: () => import('@/views/admin/auditOpenShop.vue')
    },
    {
        path: '/pages/admin/ApplyGoldWithdrawal',
        name: '/pages/admin/ApplyGoldWithdrawal',
        component: () => import('@/views/admin/ApplyGoldWithdrawal.vue')
    },
    {
        path: '/pages/admin/adminServ',
        name: '/pages/admin/adminServ',
        meta: { title: '上架服务' },
        component: () => import('@/views/admin/adminServ.vue')
    },
    {
        path: '/pages/admin/AdminRefundCart',
        name: '/pages/admin/AdminRefundCart',
        component: () => import('@/views/admin/AdminRefundCart.vue')
    },
    {
        path: '/pages/admin/AccountWithdrawalApplyListManage',
        name: '/pages/admin/AccountWithdrawalApplyListManage',
        component: () => import('@/views/admin/AccountWithdrawalApplyListManage.vue')
    },
    {
        path: '/pages/admin/AccountWithdrawalApplyFkManage',
        name: '/pages/admin/AccountWithdrawalApplyFkManage',
        component: () => import('@/views/admin/AccountWithdrawalApplyFkManage.vue')
    },
    {
        path: '/pages/admin/AccountWithdrawalApplyShManage',
        name: '/pages/admin/AccountWithdrawalApplyShManage',
        component: () => import('@/views/admin/AccountWithdrawalApplyShManage.vue')
    },
    {
        path: '/pages/admin/AccountBondObjDetail',
        name: '/pages/admin/AccountBondObjDetail',
        component: () => import('@/views/admin/AccountBondObjDetail.vue')
    },
    {
        path: '/pages/admin/AccountBond',
        name: '/pages/admin/AccountBond',
        component: () => import('@/views/admin/AccountBond.vue')
    },
    {
        path: '/pages/admin/index',
        name: '/pages/admin/index',
        component: () => import('@/views/admin/index.vue')
    },
    {
        path: '/pages/admin/addChainProduct',
        name: '/pages/admin/addChainProduct',
        component: () => import('@/views/admin/addChainProduct.vue')
    },
    {
        path: '/pages/admin/editChainProduct',
        name: '/pages/admin/editChainProduct',
        component: () => import('@/views/admin/editChainProduct.vue')
    }
]